import { FormEventHandler } from 'react';
import { UI_Notification } from 'ui/components/3-organisms/Notification/Notification';

export interface FormProps {
	className?: string;
	children: React.ReactNode;
	errorSummary?: number;
	onSubmit?: FormEventHandler<HTMLFormElement>;
}

export const UI_Form = ({ className, children, errorSummary, onSubmit }: FormProps) => {
	let errorMessage: React.ReactNode;
	if (errorSummary > 0) {
		//TODO: Remove hardcoded text
		errorMessage = (
			<UI_Notification hidden>
				<p>Indsendelsen fejlede. Der er i alt {errorSummary} fejl.</p>
			</UI_Notification>
		);
	}
	return (
		<form className={className} onSubmit={onSubmit}>
			{errorMessage}
			{children}
		</form>
	);
};
